import React from "react"

import { ContentContainer, Title, Description } from "./icon-content.style"

const IconContent = ({ icon, title, description }) => {
  return (
    <ContentContainer>
      <img src={icon} alt="" />
      <Title>{title}</Title>
      <Description>{description}</Description>
    </ContentContainer>
  )
}

export default IconContent
